module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-4d873ce1.png";